export const SHIPMENT_DISPATCH_TYPE = {
  AUTO: 'auto',
  MANUAL: 'manual',
} as const

export const SHIPMENT_DISPATCH_TYPE_MAP = {
  [SHIPMENT_DISPATCH_TYPE.AUTO]: '系統審核',
  [SHIPMENT_DISPATCH_TYPE.MANUAL]: '人工審核',
} as const

export const SHIPMENT_DISPATCH_STATUS = {
  AUTO_SUCCESS: 'auto_success',
  AUTO_FAILED: 'auto_failed',
  MANUAL: 'manual',
} as const

export const SHIPMENT_DISPATCH_STATUS_MAP = {
  [SHIPMENT_DISPATCH_STATUS.AUTO_SUCCESS]: '拋單成功',
  [SHIPMENT_DISPATCH_STATUS.AUTO_FAILED]: '拋單失敗',
  [SHIPMENT_DISPATCH_STATUS.MANUAL]: '人工建立',
} as const
